import React, { useEffect, useState, useCallback } from "react";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { t } from "@/i18n";

const MEDAL = { 1: "🥇", 2: "🥈", 3: "🥉" };

export default function Leaderboard() {
  const { lang } = useLang();
  const [rows, setRows] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/social/leaderboard");
      setRows(data.rows || []);
    } catch (e) {
      console.warn("leaderboard fetch failed", e?.message || e);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Only render if there's more than just the user
  if (rows.length <= 1) return null;

  return (
    <div className="p-6 rounded-2xl border border-border bg-card" data-testid="leaderboard">
      <div className="flex items-center gap-2 mb-4">
        <Trophy className="w-4 h-4 text-accent" strokeWidth={1.5} />
        <div className="text-xs uppercase tracking-widest text-accent font-medium">
          {t(lang, "leaderboard_title") || "Friends leaderboard"}
        </div>
      </div>
      <div className="space-y-2">
        {rows.slice(0, 10).map((r) => (
          <div
            key={r.id}
            className={`flex items-center gap-3 p-3 rounded-lg ${r.is_you ? "bg-accent/10 border border-accent/30" : "bg-secondary/30"}`}
            data-testid={`leaderboard-row-${r.rank}`}
          >
            <div className="w-8 h-8 flex items-center justify-center text-lg font-mono">
              {MEDAL[r.rank] || r.rank}
            </div>
            <div className="flex-1 min-w-0 truncate text-sm font-medium">
              {r.name} {r.is_you && <span className="text-xs text-accent">· {t(lang, "you") || "you"}</span>}
            </div>
            <div className="text-sm font-mono text-muted-foreground">{r.xp} XP</div>
          </div>
        ))}
      </div>
    </div>
  );
}
